/**
 * Import CSS
 */
import './tooltip.css';

/**
 * Import global variables
 */
import {lang, map} from '/main';
import {replaceTextPlaceholder} from '/src/modules/language/language';

/**
 * Display a tooltip when hovering a "Booth" feature
 * @param {*} pixel
 */
export default function displayFeatureInfo(pixel) {
  let info = document.getElementById('info');
  let target = document.getElementById('flayrMap');
  let tooltipContainer = document.getElementById('iTooltip');
  let header = document.getElementById('iHeader');

  info.style.left = (pixel[0] + 20) + 'px';
  info.style.top = (pixel[1] + 20) + 'px';

  if ((info.offsetLeft + info.offsetWidth) > document.body.offsetWidth) {
    info.style.left = (pixel[0] - info.offsetWidth - 20) + 'px';
  }

  if ((info.offsetTop + info.offsetHeight) > document.body.offsetHeight) {
    info.style.top = (pixel[1] - info.offsetHeight - 20) + 'px';
  }

  let feature = map.forEachFeatureAtPixel(pixel, function(feature) {
    return feature;
  });

  if (feature && feature.get('type') === 'Stand') {
    while (tooltipContainer.firstChild) {
      tooltipContainer.removeChild(tooltipContainer.firstChild);
    }
    info.style.display = 'none';

    if (typeof feature.get('number') && feature.get('number') !== null) {
      header.innerHTML = lang['tooltipBooth'] + ' ' + feature.get('number');
    } else {
      if (typeof feature.get('mainExhibitor') !== 'undefined') {
        header.innerHTML = feature.get('mainExhibitor')[0].name;
      } else {
        info.querySelector('.header').setAttribute('style', 'display: none');
        info.querySelector('.divider').setAttribute('style', 'display: none');
      }
    }

    info.querySelector('.header').setAttribute('style', '');
    info.querySelector('.divider').setAttribute('style', '');

    if (typeof feature.get('mainExhibitor') !== 'undefined' && feature.get('mainExhibitor').length > 0) {
      let tooltipRow = document.createElement('div');
      let logo = document.createElement('div');
      let name = document.createElement('div');
      tooltipRow.className = 'infoRow';
      tooltipRow.id = 'iRow';
      logo.className = 'infoImage';
      logo.id = 'iImage';
      name.className = 'infoName';
      name.id = 'iName';

      if (feature.get('mainExhibitor')[0].logo !== null || feature.get('mainExhibitor')[0].logo !== '') {
        logo.innerHTML = '<img src="' + feature.get('mainExhibitor')[0].logo + '"/>';
      } else {
        logo.innerHTML = '';
      }

      name.innerHTML = feature.get('mainExhibitor')[0].name;

      tooltipRow.appendChild(logo);
      tooltipRow.appendChild(name);
      tooltipContainer.appendChild(tooltipRow);
    } else {
      tooltipContainer.innerHTML = 'leer';
    }

    if (feature.get('coExhibitor') !== undefined && feature.get('coExhibitor').length > 0) {
      let divider = document.createElement('div');
      divider.className = 'divider';
      tooltipContainer.appendChild(divider);

      for (let ce = 0; ce < feature.get('coExhibitor').length; ce++) {
        let tooltipRow = document.createElement('div');
        tooltipRow.className = 'infoRow';
        tooltipRow.id = 'iRow' + ce;

        let ceImage = document.createElement('div');
        ceImage.className = 'infoImage';
        ceImage.id = 'iImage' + ce;
        if (feature.get('coExhibitor')[ce].logo !== null) {
          ceImage.innerHTML = '<img src="' + feature.get('coExhibitor')[ce].logo + '"/>';
        }

        let ceName = document.createElement('div');
        ceName.className = 'infoName';
        ceName.id = 'iName' + ce;
        ceName.innerHTML = feature.get('coExhibitor')[ce].name;

        tooltipRow.appendChild(ceImage);
        tooltipRow.appendChild(ceName);

        tooltipContainer.appendChild(tooltipRow);
      }
    }

    info.style.display = 'block';
    target.style.cursor = 'pointer';
  } else if (feature && feature.get('type') === 'Marker') {
    while (tooltipContainer.firstChild) {
      tooltipContainer.removeChild(tooltipContainer.firstChild);
    }
    info.style.display = 'none';

    info.querySelector('.header').setAttribute('style', 'display: none');
    info.querySelector('.divider').setAttribute('style', 'display: none');

    let tooltipRow = document.createElement('div');
    let name = document.createElement('div');
    tooltipRow.className = 'infoRow';
    tooltipRow.id = 'iRow';
    name.className = 'infoName';
    name.id = 'iName';

    let featureName = feature.get('name');

    featureName = replaceTextPlaceholder(featureName);

    name.innerHTML = featureName;

    tooltipRow.appendChild(name);
    tooltipContainer.appendChild(tooltipRow);

    info.style.display = 'block';
    target.style.cursor = 'pointer';
  } else {
    while (tooltipContainer.firstChild) {
      tooltipContainer.removeChild(tooltipContainer.firstChild);
    }
    info.style.display = 'none';
    target.style.cursor = '';
  }
}
